import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AdminShell } from "@/components/admin/AdminShell";

/** Auth gate – unchanged behaviour: unauthenticated users go to /admin/login and come back afterwards. */
export const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="flex min-h-screen items-center justify-center" data-testid="admin-auth-loading"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
  if (!admin) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
};

/** Pages reserved for administrators – a «bruker» lands on the oversikt instead. */
export const RequireAdmin = ({ children }) => {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/admin" replace />;
  return children;
};

/** The admin layout is the shared AdminShell (sidebar + topbar + mobile nav + dirty guard). */
export const AdminLayout = () => <AdminShell />;
